import styled from "styled-components";

export const TabStylesWraper = styled.div`
  font-family: "Nunito";
  & > .nav {
    color: #293134;
  }

  & > .nav > .nav-item > .nav-link {
    color: #293134;
    border-radius: 0;
  }

  & > .nav > .nav-item > .nav-link:hover {
    color: #f0292a;
  }
  & > .nav > .nav-item > .nav-link.active {
    color: #f0292a;
    border-bottom: 2px solid #f0292a;
  }
`;
